export default __webpack_public_path__ + "static/media/Social_icon.bd9d75fb.svg";